<script setup>
import { useNewsStore } from '@stores/news'
import NewsCard from '@components/news/NewsCard.vue'
import Loading from '@components/global/Loading.vue'

const news = useNewsStore()
</script>

<template>
	<Loading v-if="news.articles?.length === 0" />
	<template v-else>
		<section class="mt-24">
			<div class="container">
				<NewsCard :article="news.articles[0]" featured />
			</div>
		</section>
		<section class="my-10">
			<div class="container">
				<div class="flex flex-col gap-5">
					<NewsCard v-for="article in news.articles.slice(1)" :key="article.slug" :article="article" />
				</div>
			</div>
		</section>
	</template>
</template>
